module.exports = __webpack_public_path__ + "img/preview-all-round-protection.49f91182.png";